import { render } from "./PracticeError.vue?vue&type=template&id=7f9ef0bf&scoped=true"
import script from "./PracticeError.vue?vue&type=script&lang=js"
export * from "./PracticeError.vue?vue&type=script&lang=js"

import "./PracticeError.vue?vue&type=style&index=0&id=7f9ef0bf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9ef0bf"]])

export default __exports__